import script from "./FormDeleterDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormDeleterDialog.vue?vue&type=script&setup=true&lang=ts"

import "./FormDeleterDialog.vue?vue&type=style&index=0&id=2c0817cd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c0817cd"]])

export default __exports__